import React, { useCallback, useRef } from 'react'
import cx from 'classnames'
import { scrollTo } from 'libraries/front-end-core/helpers/document'
import SearchBoxContainer from 'redux/containers/components/layout/search/SearchBoxContainer'
import Icon from 'components/shared/Icon'

export const PageIcon = ({ searchTypeName, searchTypes, className }) => {
  const [{ icon, image } = {}] = searchTypes
    .filter(({ typeName }) => typeName === searchTypeName)

  return icon ? <Icon className={className} name={icon} /> : <img src={image} className={className} />
}

const Search = ({
  aol,
  aolConfigLoaded,
  searchType,
  setCurrentSearchType,
  submitSearchUpdate,
  query,
  flavour,
  params,
  className,
  children,
  setCurrentSearchPhrase,
  pageId
}) => {
  const inputRef = useRef()

  const handleFormOnSubmit = useCallback((e) => {
    e && e.preventDefault()

    setCurrentSearchPhrase(
      // Required due to formatting issues when copy pasting from word
      inputRef.current.value
        .replace(/^\s+/, '')
        .replace(/\s+/g, ' ')
        .replace(/[^a-zA-Z0-9\s'.%£$€&"'[\]]\(\)/g, '')
    )
    submitSearchUpdate({ params, query })
    scrollTo({ pageId, id: 0 })
    inputRef.current.blur()
  }, [params, query, inputRef])

  return (
    <nav role='navigation' className={cx(`${flavour}-search`, className)}>
      <form role='search' autoComplete='off' onSubmit={handleFormOnSubmit} className='mhauto-t'>
        <SearchBoxContainer
          {...{
            inputRef
          }}
        />
      </form>
      {children}
    </nav>
  )
}

export default Search
